import { LETTERS, RESCUES } from './vocabulary';

export const normalize = (value = '') => value.toLowerCase().normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '').replace(/[^a-z]/g, '');

// Multi-word letter names ("double you", "x ray") are collapsed to one token
// before splitting, so hyphenated or run-together forms also resolve.
const MULTI_WORD = Object.keys(LETTERS).filter(key => key.includes(' '))
  .map(key => ({ pattern: new RegExp(`\\b${key.replace(' ', '[ -]?')}\\b`, 'g'), key }));
const lookupLetter = token => LETTERS[token] || LETTERS[token.replace(/-/g, ' ')];

const tokenize = (transcript = '') => {
  let cleaned = transcript.toLowerCase().replace(/\b(?:letter|capital|as in)\b/g, ' ')
    .replace(/[^a-z-]+/g, ' ').trim();
  if (!cleaned) return [];
  MULTI_WORD.forEach(({ pattern, key }) => { cleaned = cleaned.replace(pattern, key.replace(' ', '-')); });
  return cleaned.split(/\s+/);
};

export const parseSpokenLetters = (transcript = '') => {
  const tokens = tokenize(transcript);
  if (!tokens.length) return '';
  const decoded = tokens.map(lookupLetter);
  if (decoded.every(Boolean)) return decoded.join('');
  // Browsers sometimes return a compact sequence such as "h e s" as "hes".
  if (tokens.length === 1 && /^[a-z]{2,}$/.test(tokens[0]) && transcript.includes(' ')) return tokens[0];
  return '';
};

// Lenient decode: tokens may also come from RESCUES. Returns '' if any token
// is unknown. Callers must only accept the result when it matches the target.
export const rescueSpokenLetters = (transcript = '') => {
  const tokens = tokenize(transcript);
  if (!tokens.length) return '';
  const decoded = tokens.map(token => lookupLetter(token) || RESCUES[token]);
  return decoded.every(Boolean) ? decoded.join('') : '';
};

export const chooseSpokenLetters = (transcripts, prefix, expected) => {
  const parsed = transcripts.map(parseSpokenLetters).filter(Boolean);
  const matchingParsed = parsed.find(value => expected.startsWith(prefix + value));
  if (matchingParsed) return matchingParsed;
  if (parsed[0]) return parsed[0];
  const rescued = transcripts.map(rescueSpokenLetters).filter(Boolean);
  return rescued.find(value => expected.startsWith(prefix + value)) || '';
};
